// extracted by mini-css-extract-plugin
module.exports = {"ava":"ava-module--ava--2KH4w","container":"ava-module--container--EP790","link":"ava-module--link--3libe"};